import { Helmet } from 'react-helmet-async';
import { TITLES } from '../types/titles';
import DocumentLayout from '../components/document';

const Document = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.DOCUMENT.INDEX}</title>
			</Helmet>
			<DocumentLayout />
		</>
	);
};

export default Document;
